export default __webpack_public_path__ + "static/media/visual-gradient.c3590bc2.png";